<template>
  <div>
    <div class="main-container">
      <div
        class="page-heading d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center pointer" @click="gotoback()">
          <img src="../../assets/bckarrow.svg" alt="" />
          <div class="main-head ml-4">
            <span>Share offer letter</span>
          </div>
        </div>
      </div>
      <div class="templates-container d-flex justify-content-between mt-3">
        <div class="template-left-container mr-2 p-3">
          <div class="pl-5 pr-5 template-left-container-cards">
            <div v-for="(offer, index) in offerLetters" :key="index">
              <div class="template-background pl-4 pr-4 pt-3 pb-3">
                <div class="template-card" v-html-safe="offer.html"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="template-right-container p-3">
          <div class="templatecards-heading">
            Expiry date to the Offer letter
          </div>
          <div class="topDiv datepicker-cust">
            <label class="datefieldsetStyle"
              >Expiry Date&nbsp;<span class="asterik">*</span></label
            >
            <b-form-datepicker
              ref="dob"
              class="inputField pointer"
              v-model="$v.expirydate.$model"
              :class="{ error: $v.expirydate.$error }"
            ></b-form-datepicker>
            <div
              class="validationicon"
              v-if="$v.expirydate.$dirty && !$v.expirydate.required"
              v-b-popover.hover.top.v-danger="{ content: 'Required' }"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
            <img
              @click="gotoexpdate"
              class="calender-class pointer"
              alt=""
              src="../../assets/calenderIcon.svg"
            />
          </div>
          <div
            class="offer-button d-flex align-items-center justify-content-end"
          >
            <b-button
              :disabled="isDisabled"
              class="addbtn"
              v-b-modal.confirmationmodal
            >
              <span>Share offer letter</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- preview modal -->
    <b-modal id="previewmodal" centered hide-footer hide-header>
      <div class="xMarkCancel">
        <img src="../../assets/xmark.svg" alt="" />
      </div>
      Previwed template appears here
    </b-modal>
    <!-- preview modal ends -->

    <!-- notification modal -->
    <b-modal id="confirmationmodal" centered hide-footer hide-header>
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        Confirmation
      </div>
      <div class="xMarkCancel" @click="$bvModal.hide('confirmationmodal')">
        <img src="../../assets/xmark.svg" alt="" />
      </div>
      <hr />
      <div class="mt-3">
        <span class="confirm-txt"
          >The offer letter will be sent to Opshead for approval</span
        >
      </div>

      <div class="d-flex align-items-center justify-content-end mt-3">
        <b-button class="addbtn pl-4 pr-4" @click="sharingofferletterdetails()"
          >OK</b-button
        >
      </div>
    </b-modal>
    <!-- notification modal ends -->
  </div>
</template>
<script>
import {
  putofferletter,
  getofferletterhtml,
  sendForApproval,
} from "../../utils/apiFunctions";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import toast from "../../components/mixin/toast";
export default {
  name: "TemplatesOfferLetter",
  mixins: [toast],

  data() {
    return {
      expirydate: "",
      html: "",

      candidateID: "",
      index: 25,
      decldata: [
        { id: 0, data: "" },
        { id: 1, data: "" },
        { id: 2, data: "" },
        { id: 3, data: "" },
      ],
      selectedOffer: [],
      templateSeleted: [],
      offerLetters: [],
      data: [],
      onlyData: {},
    };
  },
  validations() {
    return {
      expirydate: {
        required,
      },
    };
  },

  computed: {
    ...mapGetters("hrPortalReferenceVUEX", {
      selectCandidate: "saveSelectCandidate",
    }),
    isDisabled() {
      return !this.expirydate;
    },
  },
  created() {
    this.candidateID = this.$route.params.candidateID;

    this.gethtml();
  },
  methods: {
    async gethtml() {
      let payload = {
        candidateID: this.selectCandidate.candidateID,
        offeredCTC: this.selectCandidate.offeredCTC,
      };
      const res = await getofferletterhtml(payload);
      if (res.status == 200) {
        this.offerLetters = res.data.data;
      }
    },
    gotoback() {
      this.$router.push({
        name: this.$route.query.redirect,
        params: {
          candidateID: this.selectCandidate.candidateID,
        },
        query: {
          redirect: this.$route.query.to,
        },
      });
    },
    gotoexpdate() {
      this.$refs.dob.$el.children[0].click();
    },
    async sharingofferletterdetails() {
      this.selectCandidate.template = 1;
      const expDate = this.selectCandidate;
      expDate["expiryDate"] = this.expirydate;
      const response = await putofferletter(this.selectCandidate);
      if (response.status == 200) {
        this.$bvModal.hide("confirmationmodal");
        if (this.$route.query.redirect == "EditOfferLetter") {
          let payload = {
            candidateID: this.selectCandidate.candidateID,
          };
          const res = await sendForApproval(payload);
          if (res.status == 200) {
            this.$nextTick(() => {
              this.successModal("Offer letter sent for approval successfully");
            });
          } else {
            this.$nextTick(() => {
              this.errorModal("Something went wrong");
            });
          }
        } else {
          this.$nextTick(() => {
            this.successModal("Offer letter sent for approval successfully");
          });
        }
        this.$router.push({
          name: this.$route.query.to,
        });
      } else {
        this.errorModal("Something went wrong");
      }

      this.$store.commit("hrPortalReferenceVUEX/saveSelectCandidate", {});
    },
  },
};
</script>

<style>
.confirm-txt {
  font-weight: 400;
  font-size: 14px;
  color: #545454;
}
.offer-button {
  position: absolute;
  right: 32px;
  bottom: 20px;
  border-radius: 3px;
}
.offer-previewbtn {
  width: 100px;
  height: 32px;
  background: #fcfcfc;
  border: 1px solid #72738e;
  border-radius: 3px;
  padding: 5px 10px;
}
.offer-template-selectbtn {
  width: 281px;
  height: 29px;
  position: absolute;
  bottom: 0;
  background: #e4e4f2;
  border-radius: 0px 0px 4px 4px;
}
.offer-template-conatainer {
  width: 281px;
  height: 376px;
  background: #f3f3f3;
  border-radius: 5px;
  position: relative;
}
.offer-template-content:hover {
  -webkit-filter: grayscale(100%) blur(2px);
  filter: grayscale(100%) blur(2px);
  transition: 0.4s ease-in-out;
}
.offer-template-conatainer > div:nth-of-type(2) {
  display: none;
}

.offer-template-content:hover .offer-template-conatainer > div:nth-of-type(2) {
  position: absolute;
  top: 50%;
  display: block;
  font-weight: 500;
  font-size: 13px;
  color: #72738e;
  z-index: 7;
  left: 50%;
  text-align: center;
  transition: 0.4s ease-in-out;
  margin: 0;
}
.offer-template-content {
  width: 250px;
  height: 316px;
  margin: 15px;
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
}
.template-background {
  background: #f3f3f3;
  border-radius: 9.51957px;
}
.template-card {
  background: white;
}
.templates-container {
  border-radius: 8px;
  padding: 15px;
}
.template-left-container {
  background: #ffffff;
  border-radius: 8px;
  width: 70%;
  box-shadow: 0px 0px 14px rgb(196 196 196 / 50%);
  overflow: auto;
  height: calc(100vh - 165px);
}
.template-right-container {
  width: 30%;
  background: #ffffff;
  box-shadow: 0px 0px 14px rgb(196 196 196 / 50%);
  border-radius: 8px;
  overflow: auto;
  height: calc(100vh - 165px);
}
.template-left-container-cards {
  overflow: auto;
  height: calc(100vh - 250px);
}
</style>
